module.exports = __webpack_public_path__ + "static/media/israel.66d49a1a.svg";